<template>
  <div>
    <el-select style="width: 300px" v-model="self_project_id" filterable placeholder="请选择">
      <el-option
        v-for="item in project_list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";

export default {
  name: "SelectProject",
  props:{
    contract_area_id:{
      type:Number|String,
      default(){
        return 0;
      }
    },
    project_id:{
      type:Number|String,
      default(){
        return 0;
      }
    }
  },
  model: {
    prop: "project_id", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  created() {
    this.self_project_id=this.project_id;
    this.getList();
  },
  data(){
    return {
      keyword:"",
      project_list:[],
      self_project_id:""
    }
  },
  methods:{
    getList(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);

      if(this.contract_area_id){
        if(this.contract_area_id.indexOf(',')!==-1){
          let contract_area_ids=this.contract_area_id.split(',')
          where.contract_area_ids=contract_area_ids[contract_area_ids.length-1]
        }else {
          where.contract_area_ids=this.contract_area_id;
        }
      }
      this.project_id&&(where.id=this.project_id);
      CommonHelp.get("Project/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.project_list=(res.data||{}).list||[];
        }
      })
    }
  },
  watch:{
    contract_area_id(n){
      if(n){
        this.getList();
      }else {
        this.project_list=[]
      }
    },
    project_id(n){
      this.self_project_id=n;
    },
    self_project_id(n){
      this.$emit("success",n);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/SelectProject.vue